import React from 'react';
import SelectorGrid from "../../form/SelectorGrid/SelectorGrid";
import {AddressFormatter, DateTimeFormatter, remoteOptionFormatter} from "../../../utils/formatters";
import PrintButton from "../../form/PrintButton";
import Button from "../../form/Button";
import {postData} from "../../../utils/request";
import {optionFilter} from "../../../utils/filters";

class ConsignmentReportList extends React.Component {

    refresh = () => {
        this.list && this.list.refresh();
    }

    refreshBackground = () => {
        this.list && this.list.refreshBackground();
    }

    render() {
        const filterable = true;
        const sortable = true;
        const {view, componentConfig, filter, selection, isLoading, selectionMode} = this.props;
        const props = {componentConfig, filter, loading: isLoading, pageSize: 5, formId: this.props.formId};
        if (view) {
            props.view = view;
        }
        if (Array.isArray(props.view)) {
            props.view = [...props.view, "consignor"];
        } else if (props.view instanceof Object) {
            props.view = {...props.view, consignor: ""};
        } else {
            props.view = ["consignor"];
        }
        if (this.props.filter) {
            props.filter = [...props.filter];
        } else {
            props.filter = [];
        }
        return (
            <SelectorGrid
                className={"p-small-table"}
                selectionMode={selectionMode}
                selection={selection}
                ref={(el) => this.list = el}
                gridid={this.props.gridid !== undefined ? this.props.gridid : "ConsignmentReportList"}
                {...props}
                orderBy={{field: componentConfig.idfield, direction: "DESC"}}
                columns={{
                    [componentConfig.idfield]: {
                        header: 'Kód',
                        width: 1,
                        filterable,
                        sortable,
                    },
                    "startdate": {
                        header: 'Időszak kezdete',
                        width: 2,
                        sortable,
                        filterable,
                        renderer: DateTimeFormatter
                    },
                    "enddate": {
                        header: 'Időszak vége',
                        width: 2,
                        sortable,
                        filterable,
                        renderer: DateTimeFormatter
                    },
                    ...(this.props.actions === true ? {"consignor.name": {
                        header: 'Partner',
                        width: 2,
                        sortable,
                        filterable,
                    },
                    "action.view": {
                        header: " ",
                        width: 1,
                        renderer: (v, rowData) => {
                            return (
                                <PrintButton
                                    {...this.props}
                                    type="excel"
                                    values={rowData}
                                    block={true}
                                    size="xs"
                                    icon={{lib: "fas", name: "download"}}
                                    color="default"
                                    disabled={this.props.isLoading}
                                >
                                    Letöltés
                                </PrintButton>
                            );
                        }
                    },
                    "action.send": {
                        header: " ",
                        width: 1,
                        renderer: (v, rowData) => {
                            return (
                                <Button
                                    block={true}
                                    color="default"
                                    size="xs"
                                    icon={{lib: "fa", name: "paper-plane"}}
                                    disabled={this.props.isLoading}
                                    onClick={() => {
                                        this.props.processAction(async () => {
                                            return await postData({
                                                action: 'ConsignmentReport.send',
                                                [this.props.componentConfig.idfield]: rowData[this.props.componentConfig.idfield]
                                            });
                                        });
                                    }}
                                >
                                    Küldés
                                </Button>
                            );
                        }
                    }} : {}),
                    "state": {
                        header: "Állapot",
                        width: 1,
                        operator: "=",
                        filterable: optionFilter("ConsignmentReportStatus"),
                        renderer: remoteOptionFormatter("ConsignmentReportStatus")
                    }
                }}
                onSelectionChange={(selection) => this.props.loadForm(selection.value)}
            />
        );
    }
}

export default ConsignmentReportList;
